import { css, etiColors, mediaQueries, resetButtonStyle } from '@eti/styles';
import { DIRECTIONS, useDirection, useTranslation } from '@eti/providers';
import { Icon } from '@eti/components';
import ProgressBar from './ProgressBar';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// todo: Move to /seat-map/utils/constants.ts
export const Direction = {
  LEFT: 'left',
  RIGHT: 'right',
  PREVIOUS: 'previous',
  NEXT: 'next'
};
const wrapperStyles = css`
  display: flex;
  justify-content: center;
  margin-bottom: 0.625rem;
  position: relative;

  @media ${mediaQueries.medium.up} {
    margin-bottom: 1.25rem;
  }
`;
const buttonWrapperStyles = css`
  height: 1.125rem;
  min-height: 1.125rem;
  min-width: 1.125rem;
  width: 1.125rem;
`;
const switchSegmentButtonStyles = css`
  cursor: pointer;
  height: 1.125rem;
  ${resetButtonStyle};
  position: relative;
  width: 1.125rem;
  z-index: 3;
`;
const getFadeLinearBackground = direction => direction === 'left' ? `linear-gradient(to right,#16384b,rgba(22, 56, 75, 0) 50%)` : `linear-gradient(to left,#264a5f,rgba(22, 56, 75, 0) 50%);`;
const fadeStyles = direction => css`
  background-image: ${getFadeLinearBackground(direction)};
  height: 40px;
  ${`${direction}: 31px`};
  pointer-events: none;
  position: absolute;
  top: -10px;
  width: 100px;
  z-index: 2;

  @media ${mediaQueries.medium.up} {
    display: none;
  }
`;
const getIconRotationDirection = (docDirection, direction) => {
  if (docDirection === DIRECTIONS.LTR) {
    return direction === 'previous' ? 'rotate(90deg)' : 'rotate(-90deg)';
  }
  return direction === 'previous' ? 'rotate(-90deg)' : 'rotate(90deg)';
};
const iconStyles = (docDirection, direction) => css`
  fill: ${etiColors.white};
  height: 1.125rem;
  transform: ${getIconRotationDirection(docDirection, direction)};
  width: 1.125rem;
`;
const stepsStyles = css`
  align-items: flex-start;
  color: ${etiColors.black};
  display: flex;
  margin: 0 0.875rem;
  overflow: auto hidden;
  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${mediaQueries.medium.up} {
    max-width: 100%;
  }
`;
const StepIndicator = _ref => {
  let {
    children,
    onNextSegmentClick,
    onPreviousSegmentClick,
    innerRef,
    isFirstSegment,
    isLastSegment,
    length,
    shouldHidePointIndicator,
    progress,
    shouldShowSummary
  } = _ref;
  const {
    direction
  } = useDirection();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs("div", {
    className: wrapperStyles,
    children: [/*#__PURE__*/_jsx("div", {
      ref: innerRef
    }), /*#__PURE__*/_jsx("div", {
      className: buttonWrapperStyles,
      children: !isFirstSegment && /*#__PURE__*/_jsx("button", {
        "aria-label": t('ScreenReader.Product.SeatMap.PreviousSegment.button.Text'),
        className: switchSegmentButtonStyles,
        "data-testid": "seatMap-stepIndicator-previousButton",
        onClick: onPreviousSegmentClick,
        type: "button",
        children: /*#__PURE__*/_jsx(Icon, {
          className: iconStyles(direction, Direction.PREVIOUS),
          id: "chevron-down"
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: fadeStyles(Direction.LEFT)
    }), /*#__PURE__*/_jsxs("div", {
      className: stepsStyles,
      ref: innerRef,
      children: [/*#__PURE__*/_jsx(ProgressBar, {
        isDone: shouldShowSummary,
        length: length !== null && length !== void 0 ? length : 0,
        progress: progress !== null && progress !== void 0 ? progress : 0,
        shouldHidePointIndicator: shouldHidePointIndicator
      }), children]
    }), /*#__PURE__*/_jsx("div", {
      className: fadeStyles(Direction.RIGHT)
    }), /*#__PURE__*/_jsx("div", {
      className: buttonWrapperStyles,
      children: !isLastSegment && /*#__PURE__*/_jsx("button", {
        "aria-label": t('ScreenReader.Product.SeatMap.NextSegment.button.Text'),
        className: switchSegmentButtonStyles,
        "data-testid": "seatMap-stepIndicator-nextButton",
        onClick: onNextSegmentClick,
        type: "button",
        children: /*#__PURE__*/_jsx(Icon, {
          className: iconStyles(direction, Direction.NEXT),
          id: "chevron-down"
        })
      })
    })]
  });
};
export default StepIndicator;
//# sourceMappingURL=StepIndicatorWrapper.js.map